import { LitElement, css, svg } from "lit";
//#region src/pd-loading-state/pd-logo-loader.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
/**
* Animated PD logo symbol used as a loading indicator.
*
* Renders only the intertwined P/D symbol (no company text) and loops
* the stroke-draw animation continuously: lines draw forward, then
* erase backward, creating a smooth "breathing" loading effect.
*
* @tagname pd-logo-loader
* @cssprop --pd-logo-loader-col - Stroke color. Default: `var(--pd-loading-state-loader-fg)`.
* @cssprop --pd-logo-loader-size - Width and height. Default: `56px`.
* @cssprop --pd-logo-loader-stroke-width - SVG stroke width. Default: `5`.
* @cssprop --pd-logo-loader-duration - Full draw+erase cycle. Default: `2.5s`.
*/
var PdLogoLoader = class extends LitElement {
	static {
		this.styles = css`
    :host {
      display: block;
      width: var(--pd-logo-loader-size, 56px);
      height: var(--pd-logo-loader-size, 56px);
      margin: 0 auto;
    }

    svg {
      width: 100%;
      height: 100%;
    }

    .pd-path {
      stroke: var(
        --pd-logo-loader-col,
        var(--pd-loading-state-loader-fg, var(--pd-default-col, #067394))
      );
      stroke-width: var(--pd-logo-loader-stroke-width, 5);
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-miterlimit: 10;
      fill: none;
      stroke-dasharray: var(--_path-len);
      stroke-dashoffset: 0;
      animation: logo-draw var(--pd-logo-loader-duration, 2.5s) ease-in-out
        infinite alternate;
    }

    .pd-path-b {
      animation-delay: 0.15s;
    }

    @keyframes logo-draw {
      to {
        stroke-dashoffset: var(--_path-len);
      }
    }
  `;
	}
	firstUpdated() {
		const path = this.shadowRoot?.querySelector(".pd-path");
		if (path) {
			const len = path.getTotalLength();
			this.style.setProperty("--_path-len", `${len}`);
		}
	}
	render() {
		return svg`<svg viewBox="0 0 166.68 212.6" aria-hidden="true">
      <path class="pd-path" d="M123.9,80.5l3.6,0.1c6.7,0,12.2-5.5,12.2-12.2s-5.5-12.2-12.2-12.2c-6.7,0-12.2,5.5-12.2,12.2v75.8
        c0,15-12.2,27.2-27.2,27.2s-27.2-12.2-27.2-27.2c0-14.1,10.7-25.7,24.4-27.1V74.7c0-4.4-3.5-8-7.9-8c-4.4,0-8,3.6-8,8
        c0,4.4,3.6,8,8,8"/>
      <path class="pd-path pd-path-b" d="M91.7,132.1l-3.6-0.1c-6.7,0-12.2,5.5-12.2,12.2c0,6.7,5.5,12.2,12.2,12.2s12.2-5.5,12.2-12.2V68.4
        c0-15,12.2-27.2,27.2-27.2s27.2,12.2,27.2,27.2c0,14.1-10.8,25.7-24.5,27.1v42.1c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8s-3.6-8-8-8"/>
    </svg>`;
	}
};
//#endregion
export { PdLogoLoader };
